import { createTheme, responsiveFontSizes } from "@mui/material";

const theme = responsiveFontSizes(
  createTheme({
    palette: {
      primary: {
        light: "#a9cce3",
        main: "#3E4B75",
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        // light: will be calculated from palette.primary.main,
        main: "#e50071",
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      error: {
        // light: will be calculated from palette.primary.main,
        main: "#FF0000",
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
    },
    typography: {
      // h6: {
      //   fontWeight: "bolder",
      //   whiteSpace: "nowrap",
      //   maxHeight: "30px",
      //   overflow: "hidden",
      //   textOverflow: "ellipsis",
      //   textTransform: "uppercase",
      //   fontSize: "1rem",
      //   "@media (min-width:600px)": {
      //     fontSize: "1.2rem",
      //   },
      // },
    },
    props: {
      MuiButton: {
        variant: "contained",
        color: "primary",
      },
      MuiGrid: {
        spacing: 1,
      },
    },
    overrides: {
      MuiCheckbox: { root: { padding: 0, paddingLeft: 5 } },
      MuiButton: { root: { margin: "5px 0px" }, contained: { margin: 5 } },
      MuiButtonGroup: { grouped: { margin: 0 } },
      MuiTab: {
        root: {
          "@media (min-width: 600px)": {
            minWidth: "100px",
          },
        },
      },
    },
  })
);
// theme.typography.h1.color = theme.palette.primary.main;
// theme.typography.h2.color = theme.palette.primary.main;
// theme.typography.h3.color = theme.palette.primary.main;
// theme.typography.h4.color = theme.palette.primary.main;
// theme.typography.h5.color = theme.palette.secondary.main;
theme.typography.h6.color = theme.palette.primary.main;
//   color: theme.palette.primary.main,
//   whiteSpace: "nowrap",
//   maxHeight: "30px",
//   overflow: "hidden",
//   textOverflow: "ellipsis",
//   textTransform: "uppercase",
//   fontSize: "1rem",
//   "@media (min-width:600px)": {
//     fontSize: "1.2rem",
//   },
theme.typography.h6[theme.breakpoints.up("md")] = {
  fontSize: "1.4rem",
};
// };

export default theme;
